module.exports = __webpack_public_path__ + "img/en.bba04a6a.png";